// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2919":"0d7bc6e2","9371":"cf24cca9"}[chunkId] + ".chunk.css";
};